import { gql, useMutation, useQuery } from '@apollo/client'

import type { CustomerFormInput, FormField } from '@@types'

export type CustomerProfileFieldsQuery = {
  customerProfileFields?: Array<FormField | null> | null
}

export type CustomerProfileFieldsQueryVariables = {
  isRegistration?: boolean | null
}

export const GQL_QUERY_CUSTOMER_PROFILE_FIELDS = gql`
  query customerProfileFields($isRegistration: Boolean) {
    customerProfileFields(isRegistration: $isRegistration) {
      id
      order
      group
      label
      fieldName
      type
      required
      isReadOnly
      isMultiSelect
      isVisibleInRegistration
      isVisibleInProfile
      answer
      defaultValue
      fixedAnswers {
        name
        value
      }
      payload
      isAutoComplete
    }
  }
`

export const useCustomerProfileFieldsQuery = (
  variables?: CustomerProfileFieldsQueryVariables,
  options?: Parameters<
    typeof useQuery<CustomerProfileFieldsQuery, CustomerProfileFieldsQueryVariables>
  >[1],
) =>
  useQuery<CustomerProfileFieldsQuery, CustomerProfileFieldsQueryVariables>(
    GQL_QUERY_CUSTOMER_PROFILE_FIELDS,
    {
      fetchPolicy: 'cache-and-network',
      skip: options?.skip ?? false,
      ...options,
      variables,
    },
  )

export type UpdateCustomerMutation = {
  updateCustomer?: boolean | null
}

export type UpdateCustomerMutationVariables = {
  answers?: CustomerFormInput[] | null
}

export const GQL_MUTATION_UPDATE_CUSTOMER = gql`
  mutation updateCustomer($answers: [CustomerProfileFieldInput]) {
    updateCustomer(answers: $answers)
  }
`

export const useUpdateCustomerMutation = (
  options?: Parameters<typeof useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>>[1],
) => useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(GQL_MUTATION_UPDATE_CUSTOMER, options)

export type RegisterCustomerMutation = {
  registerCustomer?: boolean | null
}

export type RegisterCustomerMutationVariables = {
  answers?: CustomerFormInput[] | null
}

export const GQL_MUTATION_REGISTER_CUSTOMER = gql`
  mutation registerCustomer($answers: [CustomerProfileFieldInput]) {
    registerCustomer(answers: $answers)
  }
`

export const useRegisterCustomerMutation = (
  options?: Parameters<typeof useMutation<RegisterCustomerMutation, RegisterCustomerMutationVariables>>[1],
) => useMutation<RegisterCustomerMutation, RegisterCustomerMutationVariables>(GQL_MUTATION_REGISTER_CUSTOMER, options)

export type CheckIsEmailUsedMutation = {
  checkIsEmailUsed?: boolean | null
}

export type CheckIsEmailUsedMutationVariables = {
  email: string
}

export const GQL_MUTATION_CHECK_IS_EMAIL_USED = gql`
  mutation checkIsEmailUsed($email: String!) {
    checkIsEmailUsed(email: $email)
  }
`

export const useCheckIsEmailUsedMutation = (
  options?: Parameters<typeof useMutation<CheckIsEmailUsedMutation, CheckIsEmailUsedMutationVariables>>[1],
) => useMutation<CheckIsEmailUsedMutation, CheckIsEmailUsedMutationVariables>(GQL_MUTATION_CHECK_IS_EMAIL_USED, options)
